import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import {
  FETCH_CLAIMS_REQUEST, fetchClaimsSuccess, fetchClaimsFailure,
  CREATE_CLAIM_REQUEST, createClaimSuccess, createClaimFailure,
  UPDATE_CLAIM_REQUEST, updateClaimSuccess, updateClaimFailure,
  DELETE_CLAIM_REQUEST, deleteClaimSuccess, deleteClaimFailure
} from '../actions/claimActions';
import { getBaseUrl } from '../utils/getBaseUrl';

const API_BASE_URL = getBaseUrl();
const authToken = localStorage.getItem('authToken');
const getAuthToken = () => localStorage.getItem('authToken');

const createConfig = () => ({
  headers: { 'Authorization': `Bearer ${authToken}` }
});

function* fetchClaims(action) {
  try {
    const token = getAuthToken();
    const { projectId, page = 1, limit = 2, search = '', group = '' } = action.payload || {};

    console.log("Fetching claims data with payload: ", { projectId, page, limit, search, group });

    const baseUrl = getBaseUrl();

    const response = yield call(
      axios.get,
      `${baseUrl}/${projectId}/claims`,
      {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, limit, search, group },
      }
    );

    // Assuming response structure includes `data` and `meta`
    yield put(fetchClaimsSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || "An unknown error occurred";
    console.error("Error fetching claims data: ", errorMessage);
    yield put(fetchClaimsFailure(errorMessage));
  }
}

function* createClaim(action) {
  try {
    const response = yield call(axios.post, `${API_BASE_URL}/${action.payload.projectId}/claims`, action.payload.data, createConfig());
    yield put(createClaimSuccess(response.data));
  } catch (error) {
    yield put(createClaimFailure(error.message));
  }
}

function* updateClaim(action) {
  try {
    const { id, data, projectId } = action.payload;
    const response = yield call(axios.put, `${API_BASE_URL}/${projectId}/claims/${id}`, data, createConfig());
    yield put(updateClaimSuccess(response.data));
  } catch (error) {
    yield put(updateClaimFailure(error.message));
  }
}

function* deleteClaim(action) {
  try {
    const { id, projectId } = action.payload;
    yield call(axios.delete, `${API_BASE_URL}/${id}/claims/${projectId}`, createConfig());
    yield put(deleteClaimSuccess(id));
  } catch (error) {
    yield put(deleteClaimFailure(error.message));
  }
}

export default function* claimSaga() {
  yield takeLatest(FETCH_CLAIMS_REQUEST, fetchClaims);
  yield takeLatest(CREATE_CLAIM_REQUEST, createClaim);
  yield takeLatest(UPDATE_CLAIM_REQUEST, updateClaim);
  yield takeLatest(DELETE_CLAIM_REQUEST, deleteClaim);
}
